import { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import TemplateIcon from '@atlaskit/icon-lab/core/template';
import { Ati } from '@atlassian/ari';

import type { UseMenuItemProps, UseMenuItemReturnProps } from './index.tsx';

const messages = defineMessages({
	title: {
		id: 'create-blank-fabric-page.universal-create.start-from-template.title',
		defaultMessage: 'Start from template',
		description: 'title indicating that this option will open a template picker modal',
	},
});

export function useStartFromTemplateItem({ onClick }: UseMenuItemProps): UseMenuItemReturnProps {
	const intl = useIntl();
	const { formatMessage } = intl;

	const handleClick = useCallback(
		(_e: React.MouseEvent | React.KeyboardEvent) => {
			onClick('startFromTemplatePopoverItem');
		},
		[onClick],
	);

	return {
		ati: Ati.parse('ati:cloud:confluence:template'),
		children: formatMessage(messages.title),
		onClick: handleClick,
		elemBefore: TemplateIcon,
		testId: 'create-menu-start-from-template-item',
	};
}
